module.exports = __webpack_public_path__ + "img/mybareskin.ad1ee3d9.webp";